export default __webpack_public_path__ + "static/what-is-ux-audit-and-why-your-business-need-it-5a64cc4a354c6ddaa5755c4e4c7487f5.png";